/**
 * 아이콘 동적 로더
 * 
 * react-icons에서 아이콘 이름으로 아이콘 컴포넌트를 동적으로 로드
 */

import * as MdIcons from 'react-icons/md';
import { IconType } from 'react-icons';

/**
 * 아이콘 이름으로 아이콘 컴포넌트 반환
 * 
 * @param iconName - 아이콘 이름 (예: "MdDashboard")
 * @returns 아이콘 컴포넌트 또는 null
 */
export const getIcon = (iconName: string | null): IconType | null => {
  if (!iconName) {
    return null;
  }

  // react-icons/md에서 아이콘 찾기
  const IconComponent = (MdIcons as any)[iconName];
  
  if (IconComponent) {
    return IconComponent as IconType;
  }

  // 찾지 못한 경우 null 반환
  return null;
};

